<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="payment-terms"
>
  <div #modalHead [class]="lmodalHeaderClass + ' p-payment-terms'">
    <div class="p-modal-head01 p-payment-terms-header">
      <button id="payment-terms-close-btn" class="p-modal-head01__close js-modal-close" (click)="this.close()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-payment-terms-container">
      <div class="p-terms-conditions__body c-text-s">
        <div [innerHTML]="message"></div>
      </div>
    </div>
  </div>
</div>
